/**
 * Task of the integration service, as returned by `GET /tasks`. Keep the types in step with the service
 * (`finadeck-integration/src/entity/tasks`).
 */
export interface Task {
  id: number
  companyId: string
  name: string
  description: string
  application: TaskApplication
  type: TaskType
  status: TaskStatus
  startTime: string
  /** Null until the task has ended. */
  endTime: string | null
  errors?: { [key: string]: any }[]
  artefact?: { [key: string]: any }
  parentId?: number
  parent?: Task
  children?: Task[]
  /** The user who started the task; null for scheduled tasks. */
  userId?: number | null
}

export enum TaskStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED'
}

export enum TaskType {
  ACCOUNTS = 'ACCOUNTS',
  ACTUALS = 'ACTUALS',
  AGGREGATION = 'AGGREGATION',
  API = 'API',
  ARCHIVE = 'ARCHIVE',
  BANK_ACCOUNTS = 'BANK_ACCOUNTS',
  BLOCK = 'BLOCK',
  BUDGET = 'BUDGET',
  CUSTOMERS = 'CUSTOMERS',
  DAILY = 'DAILY',
  DEPARTMENT = 'DEPARTMENT',
  DEPRECATION_VOUCHERS = 'DEPRECATION_VOUCHERS',
  DIMENSIONS = 'DIMENSIONS',
  EMAIL = 'EMAIL',
  EXTENSIVE = 'EXTENSIVE',
  EXTERNAL = 'EXTERNAL',
  FILEUPLOAD = 'FILEUPLOAD',
  FIND_MATCHES = 'FIND_MATCHES',
  FISCAL_YEARS = 'FISCAL_YEARS',
  GET_AUTH = 'GET_AUTH',
  GET_FILE = 'GET_FILE',
  INITIAL = 'INITIAL',
  LOGIN = 'LOGIN',
  LOGISTICS = 'LOGISTICS',
  MONTHLY = 'MONTHLY',
  PAYMENTS = 'PAYMENTS',
  PERIOD_LOCK = 'PERIOD_LOCK',
  POLL = 'POLL',
  PRODUCTS = 'PRODUCTS',
  PROJECTS = 'PROJECTS',
  PROJECT_PHASES = 'PROJECT_PHASES',
  PURCHASES = 'PURCHASES',
  RESTAURANTS = 'RESTAURANTS',
  SALES = 'SALES',
  SHEETS = 'SHEETS',
  SHIFTACTIVITY = 'SHIFTACTIVITY',
  SIE = 'SIE',
  SUPPLIERS = 'SUPPLIERS',
  TRUNCATE = 'TRUNCATE',
  UPLOAD = 'UPLOAD',
  VEHICLES = 'VEHICLES',
  VOUCHERS = 'VOUCHERS',
  WORKHOURS = 'WORKHOURS',
  WORKTYPES = 'WORKTYPES'
}

/** The integration service's applications, except Econia, which is no longer a customer. */
export enum TaskApplication {
  AC_PANTHER = 'AC_PANTHER',
  ADMICOM = 'ADMICOM',
  BRIOX = 'BRIOX',
  BUSINESS_CENTRAL = 'BUSINESS_CENTRAL',
  EFINA = 'EFINA',
  EXCEL = 'EXCEL',
  EXCHANGE_RATES = 'EXCHANGE_RATES',
  FENNOA = 'FENNOA',
  FINADECK = 'FINADECK',
  FIVALDI = 'FIVALDI',
  FORTNOX = 'FORTNOX',
  FUTURSOFT = 'FUTURSOFT',
  GOOGLE = 'GOOGLE',
  HEEROS = 'HEEROS',
  HRSUUNTI = 'HRSUUNTI',
  KIHO = 'KIHO',
  KOTIPIZZA = 'KOTIPIZZA',
  L7_CSV = 'L7_CSV',
  L7 = 'L7',
  LEMONSOFT = 'LEMONSOFT',
  LOGISYSTEMS = 'LOGISYSTEMS',
  MAESTRO = 'MAESTRO',
  MAESTRO_CSV = 'MAESTRO_CSV',
  MAPON = 'MAPON',
  MARAPLAN = 'MARAPLAN',
  NEPTON = 'NEPTON',
  NETVISOR = 'NETVISOR',
  NETVISOR_CSV = 'NETVISOR_CSV',
  NETSUITE = 'NETSUITE',
  ONEDRIVE = 'ONEDRIVE',
  ONTIME = 'ONTIME',
  OSCAR = 'OSCAR',
  PROCOUNTOR = 'PROCOUNTOR',
  QUICKBOOKS = 'QUICKBOOKS',
  RESTOLUTION = 'RESTOLUTION',
  SEVERA = 'SEVERA',
  SIE = 'SIE',
  SIMPHONY = 'SIMPHONY',
  SONET = 'SONET',
  TALENOM = 'TALENOM',
  TAMIGO = 'TAMIGO',
  TRIPLETEX = 'TRIPLETEX',
  TULOPOS = 'TULOPOS',
  VISMANET = 'VISMANET',
  XERO = 'XERO'
}
